import { callProcedure } from 'core/classes/helpers/callProcedure'
import Logger from 'core/utils/Logger'

import { IReorderDataFn } from '../../../widgets/assortmentTab/context/models/IReorderDataFn'
import { IAssortmentGroup } from '../models/data/IAssortmentGroup'

export const applyAssortmentGroupsSortOrder: IReorderDataFn<IAssortmentGroup> = async ({
  partnerId,
  programType,
  fYear,
  data,
}) => {
  try {
    const response = await callProcedure('spJBPAssortmentGroupApplyChangesSortOrder', {
      'p.PartnerId': partnerId,
      'p.FYear': fYear,
      'p.ProgramType': programType,
      'p.Data': data.map(({ EntryId, SortOrder }) => ({
        EntryId,
        SortOrder,
      })),
    })
    return response
  } catch (e) {
    Logger.log(e)
    return []
  }
}
